import styled from 'styled-components'

export default styled.img`
  transition: opacity 0.5s ease-in-out;
  opacity: ${({ loaded }) => (loaded ? 1 : 0.5)};
  ${({ responsive }) => (responsive ? 'width: 100%' : '')};
`
